export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => state.items,
    getItem: state => status_slug => state.items.find(item => item.status_slug == status_slug),
    getByGroup: state => group => state.items.filter(item => item.group_slug == group)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: ({
      dispatch,
      getters
    }, wait = false) => {
      // Comme les status sont nécessaires au fonctionnement de toute l'appli, on les charge avant de lancer tout le reste
      // donc pour ne pas tout bloquer si on les a déjà, on vérifie, et on ne les charge que si on ne les a pas encore
      if (!getters.getAll.length) {
        let params = {
          wait: wait,
          api_url: 'status',
          api_data_path: 'statuses',
          namespace: 'status'
        }
        return dispatch('getAll', params, {
          root: true
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/status.js